import type { FC } from 'react'

interface ConnectionStatusDotProps {
  state: 'connected' | 'disconnected'
  tooltip: string
  className?: string
}

const ConnectionStatusDot: FC<ConnectionStatusDotProps> = ({ state, tooltip, className }) => {
  const colorClass = state === 'connected' ? 'bg-green-500' : 'bg-red-500'

  return (
    <span
      className={`inline-flex items-center${className ? ` ${className}` : ''}`}
      role="status"
      aria-live="polite"
      aria-atomic="true"
      title={tooltip}
    >
      <span
        aria-hidden="true"
        className={`inline-block h-3 w-3 rounded-full ${colorClass}`}
      />
      <span className="sr-only">{tooltip}</span>
    </span>
  )
}

export default ConnectionStatusDot
